import { forEach, groupBy, map } from 'lodash';
import React, { VFC, useState } from 'react';
import { useMacroOptionsContext } from '../../contexts/MacroOptionsContext';
import Button from '../elements/editors/mui/Button';
import './MacroOptions.css';
import MacroOptionsRow from './MacroOptionsRow';
import { AvailableFilters } from './types/AvailableFilters';
import { Macro } from './types/Macro';
import { MacroParts } from './types/MacroParts';

const AUTHOR = 'MacroOptions';

export interface MacroOptionsProps {
  availableFilters: AvailableFilters;
}

export const MacroOptions: VFC<MacroOptionsProps> = (props) => {
  const { segments: initialMacros, update } = useMacroOptionsContext();
  const { availableFilters } = props;
  const [macros, setMacros] = useState<(string | MacroParts)[]>(initialMacros);
  const macrosByToken = groupBy(macros, 'token');

  function onChange(type: string, value: string) {
    const newMacros: MacroParts[] = [];

    forEach(availableFilters, (filter) => {
      if (filter.type === type) {
        if (value) {
          newMacros.push({ token: type, operator: '', value });
        }
      } else if (macrosByToken[filter.type]) {
        newMacros.push({
          ...(macrosByToken[filter.type][0] as Macro),
          operator: '',
        });
      }
    });

    setMacros(newMacros);
  }

  function onCancelClicked() {
    update((current) => ({
      ...current,
      isOpen: false,
    }));
  }

  function onSearchClicked() {
    update((current) => ({
      ...current,
      segments: macros,
      author: AUTHOR,
      isOpen: false,
    }));
  }

  return (
    <div
      onFocus={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <div className="macro-options">
        <h2>Advanced Search</h2>
        {map(availableFilters, (filter, type) => (
          <MacroOptionsRow
            key={type}
            filter={filter}
            macro={
              (macrosByToken[type]?.[0] || {
                token: type,
                operator: '',
                value: '',
                segment: `${type}:`,
              }) as Macro
            }
            onChange={onChange}
          />
        ))}
      </div>
      <div className="macro-options-footer">
        <Button
          buttonTheme="cancel"
          rootStyle={{
            height: 28,
            minWidth: 60,
            marginRight: 16,
          }}
          onClick={onCancelClicked}
        >
          Cancel
        </Button>
        <Button
          buttonTheme="primary"
          rootStyle={{
            height: 28,
            minWidth: 60,
            marginRight: 0,
          }}
          onClick={onSearchClicked}
        >
          Search
        </Button>
      </div>
    </div>
  );
};
